var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-3 mt-4"},[_c('h1',{staticClass:"title"},[_vm._v("My Program")]),_c('MyProgramNavigation'),_c('MyProgramMetrics')],1)}
var staticRenderFns = []

export { render, staticRenderFns }